<template>
  <div>
    <v-data-table :loading="loading" :headers="headers" :items="SUPPLIERS.data" class="elevation-1" hide-default-footer>
      <template v-slot:[`item.is_active`]="{ item }">
        <v-icon v-if="item.is_active == 1" color="success">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:no-data> No data </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon color="warning" class="mr-2" @click.stop="edit(item)">
          mdi-pencil-box-outline
        </v-icon>
      </template>

      <template v-slot:top>
        <v-row dense class="mx-2">
          <base-column :lg="4" :md="3" :sm="6">
            <v-text-field v-model="search.search" append-icon="mdi-magnify" label="Search" outlined dense
              hide-details></v-text-field>
          </base-column>
          <base-column :lg="3" :md="3" :sm="6" v-if="(ROLE == 'Owner')">
            <v-select v-model="search.branch_id" :items="branch" item-text="name" item-value="id" label="Branch" outlined
              dense></v-select>
          </base-column>
          <base-column :lg="3" :md="3" :sm="6">
            <v-btn small color="darkblue" class="white--text" @click.stop="searching">Submit <v-icon
                right>mdi-magnify</v-icon></v-btn>
            <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
              <v-icon right>mdi-close-circle-multiple </v-icon>
            </v-btn>
          </base-column>
        </v-row>
      </template>
    </v-data-table>

    <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
  </div>
</template>

<script>
import BaseColumn from "@/components/base/BaseColumn";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "SupplierList",
  data() {
    return {
      headers: [
        { text: "Supplier Name", value: "name" },
        { text: "Owner", value: "owner" },
        { text: "Phone", value: "phone" },
        { text: "Email", value: "email" },
        { text: "Status", value: "is_active" },
        { text: "Action", value: "actions", sortable: false, width: 100 },
      ],
      page: 1,
      branch: [],
      disabled: false,
      loading: false,
      status: ["Active", "Inactive"],
      search: {
        branch_id: "",
        keyword: null,
      },
    };
  },

  created() {
    this.getSupplier();
    this.getBranch();
  },
  methods: {
    ...mapMutations("suppliers", ["SET_SUPPLIERS"]),

    async getSupplier() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        branch_id: this.search.branch_id,
        keyword: this.search.keyword,
      };

      await this.$axios
        .get("/master/supplier", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_SUPPLIERS(data.suppliers);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch.data;
        });
    },

    searching() {
      this.page = 1;
      this.getSupplier();
    },
    clear() {
      this.page = 1;
      this.search = {
        branch_id: "",
        search: "",
      };
      this.getSupplier();
    },

    edit(item) {
      this.$router.push("/master/suppliers/edit/" + item.id);
    },
  },
  computed: {
    ...mapGetters("suppliers", {
      SUPPLIERS: "Suppliers",
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    currentPage: {
      get() {
        return this.SUPPLIERS.current_page;
      },
      set(val) {
        return this.$store.commit("suppliers/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.SUPPLIERS.last_page;
      },
    },
  },

  components: {
    BaseColumn,
  },
};
</script>